"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=FocusTrapCallout.types.js.map